module.exports = __webpack_public_path__ + "img/feg_fiveelementk.cf53640.png";